import {ChangeDetectionStrategy} from '@angular/core';
import {Component} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-forward-mapp',
  template: ''
})
export class ForwardMappComponent {
  // this is a dummy component used for routing purposes
  // the actual forwarding is handled in the forwardMappGuard
}
